var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H11C11.41 1.25 11.75 1.59 11.75 2C11.75 2.41 11.41 2.75 11 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V13C21.25 12.59 21.59 12.25 22 12.25C22.41 12.25 22.75 12.59 22.75 13V15C22.75 20.43 20.43 22.75 15 22.75Z",
    fill: "#14171F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.50032 17.6905C7.89032 17.6905 7.33032 17.4705 6.92032 17.0705C6.43032 16.5805 6.22032 15.8705 6.33032 15.1205L6.76032 12.1105C6.84032 11.5305 7.22032 10.7805 7.63032 10.3705L15.5103 2.49055C17.5003 0.500547 19.5203 0.500547 21.5103 2.49055C22.6003 3.58055 23.0903 4.69055 22.9903 5.80055C22.9003 6.70055 22.4203 7.58055 21.5103 8.48055L13.6303 16.3605C13.2203 16.7705 12.4703 17.1505 11.8903 17.2305L8.88032 17.6605C8.75032 17.6905 8.62032 17.6905 8.50032 17.6905ZM16.5703 3.55055L8.69032 11.4305C8.50032 11.6205 8.28032 12.0605 8.24032 12.3205L7.81032 15.3305C7.77032 15.6205 7.83032 15.8605 7.98032 16.0105C8.13032 16.1605 8.37032 16.2205 8.66032 16.1805L11.6703 15.7505C11.9303 15.7105 12.3803 15.4905 12.5603 15.3005L20.4403 7.42055C21.0903 6.77055 21.4303 6.19055 21.4803 5.65055C21.5403 5.00055 21.2003 4.31055 20.4403 3.54055C18.8403 1.94055 17.7403 2.39055 16.5703 3.55055Z",
    fill: "#14171F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.8496 9.83027C19.7796 9.83027 19.7096 9.82027 19.6496 9.80027C17.0196 9.06027 14.9296 6.97027 14.1896 4.34027C14.0796 3.94027 14.3096 3.53027 14.7096 3.41027C15.1096 3.30027 15.5196 3.53027 15.6296 3.93027C16.2296 6.06027 17.9196 7.75027 20.0496 8.35027C20.4496 8.46027 20.6796 8.88027 20.5696 9.28027C20.4796 9.62027 20.1796 9.83027 19.8496 9.83027Z",
    fill: "#14171F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.caa6e0d96202e198709ef7cc76610426.svg";
export { ForwardRef as ReactComponent };